import * as React from 'react';
import { ClassNames, IcomoonIcon } from '@rocketmakers/armstrong-edge';
import cross from '../assets/icons/cross.svg';
import './companyPanel.scss';
import { Link } from 'gatsby';
import logoSmall from '../assets/logo-small.svg';
import rocketmakers from '../assets/rm-full-logo.svg';
import { ILocation } from '../typings/data';
import { AppContext } from '../context/appProvider';

interface IProps {
  onCompanyClick: (location: ILocation) => void;
}

const TechSparkPanel: React.FC<IProps> = ({ onCompanyClick }) => {
  const [panelOpen, setPanelOpen] = React.useState(true);
  const { allLocations } = React.useContext(AppContext);

  const featuredLocations = React.useMemo(() => {
    return allLocations
      .filter((l) => l.featured)
      .sort(() => Math.random() - 0.5)
      .slice(0, 2);
  }, [allLocations]);

  return (
    <div className={ClassNames.concat('panel company-content', 'open')}>
      <div className="panel-tab-container" onClick={() => setPanelOpen(!panelOpen)}>
        <div className="panel-tab-company techspark-overlay">
          <p>
            <img className="small-techspark-logo" alt={'techspark logo'} src={logoSmall} />
            <img alt={'techspark icon'} src={`/pins/ts-pin.svg`} />
          </p>
        </div>
      </div>
      <>
        <div className="panel-header techspark-header">
          <div className="panel-header-company-info">
            <div className="location">BRISTOL AND BATH</div>
            <h2 className="cluster-heading">Cluster Map</h2>
          </div>
          <div className="cross-mark" onClick={() => setPanelOpen(false)}>
            <img src={cross} />
          </div>
        </div>
        <div className="panel-content">
          <div className="description">
            <p>
              Bristol and Bath is one of the most exciting areas for electronics technology in the world. The heart of
              one of the largest clusters of silicon designers outside of Silicon Valley, it drives a strong eco-system
              of research, hardware, software and system design.
            </p>

            <p>
              Key design centres from global technology companies sit alongside a thriving culture of silicon start-ups
              and IP developers and a dedicated set of Special Interest Groups.
            </p>

            <p>
              Leading consultancies employ hundreds of systems architects and engineers, and the area hosts world
              leading research from the Universities of Bristol, Bath and UWE, Europe's largest robotics lab and
              research centres for Toshiba and HP Labs.
            </p>
          </div>
          <div className="more-locations-header">Featured Companies</div>
          <div className="more-locations-box">
            {featuredLocations.map((location) => (
              <div
                className="more-location-card"
                style={{ backgroundColor: '#017CD1B3' }}
                onClick={() => onCompanyClick(location)}
              >
                <div className="more-location-card-text">{location.name}</div>
              </div>
            ))}
          </div>
          <div className="btn-container">
            Do you want to be included on this map?
            <Link className="btn blue" to="/signup">
              <IcomoonIcon icon="plus3" />
              ADD A COMPANY
            </Link>
          </div>
          <div className="footer-space"></div>
        </div>
      </>
    </div>
  );
};

export default TechSparkPanel;
